module.exports = __webpack_public_path__ + "img/drawing_dongman.c17773a2.png";